export default __webpack_public_path__ + "static/media/T41.87ed8379.JPG";